<template>
  <div>
    
    <div v-if="state_setting.maintenance_mode" class="maintenance-wrapper">
      <div class="maintenance-inner">
        <img :src="this.StaticImageUrl+'assets/images/maintenance.png'" alt="">
        <h3>سایت در حال بروزرسانی می باشد.</h3>
        <p>لطفا بعد از چند دقیقه دوباره تلاش کنید.</p>
      </div>
    </div>
    <template v-else>
      <div v-if="stateLoading" class="loading-wrapper auth">
        <div class="loading-inner">
          <span class="loader"></span>
        </div>
      </div>
      <div v-if="loading" class="loading-wrapper auth">
        <div class="loading-inner">
          <span class="loader"></span>
        </div>
      </div>

      <div class="app-wrapper">
        <keep-alive :include="['Home' , 'Dashboard' , 'Header' , 'ChatBtn' , 'Pulses']">
          <transition
            name="slide-left"
            mode="out-in"
          >
            <router-view></router-view>
          </transition>
        </keep-alive>
      </div>

      <notifications group="foo" />
      
      <chat-btn position="left"></chat-btn>
      
    </template>

    
    <Modal :open="alert_modal" @close="alert_modal = false">
      <div class="ar-card" style="background:yellow">
        <div class="ar-card-header">
          <div class="ar-card-title" style="font-size:23px">
              <i class="fa fa-bullhorn mx-2" style="color:#fb6b04e0;"></i>
              مژده 
          </div>
          <span>
            <i @click="alert_modal = false" class="mdi mdi-close"></i>
          </span>
        </div>
        <div class="ar-card-body font-titr" style="font-size:25px">
          از این پس به پاس قدردانی از مشتریان ارزشمندمان ،
          <br>
          کلیه کارمزد های بانکی توسط <span style="color:red">ارزینه</span> پرداخت خواهد شد.
        </div>
      </div>
    </Modal>

  </div>
</template>
<script>
import Modal from './components/Modal.vue'
import ChatBtn from './components/ChatBtn'
import {io} from 'socket.io-client';
export default {
  name: 'App',
  data: () => ({
    loading : false,
    modal_question : false,
    alert_modal : false,
    socket : null,
    ws:null
  }),
  components:{
    ChatBtn,
    Modal
  },
  methods:{
    checkAlert () {

      this.alert_modal = true

    },
    getSetting () {
      this.$axios.get(`setting`)
      .then(res => {        
        this.StoreSetting(res.data.data)

        const latest_version = parseFloat(res.data.data.website_version);
        const version = localStorage.getItem("version");
        if(!version || version < latest_version)
        {
          localStorage.setItem("version", latest_version);
          location.reload(true)
        }
        
      })
      .catch( () => {
      });

      this.$axios.get(`getPrices`)
      .then(res => {        
        this.StorePrice(res.data.data)
      })
      .catch(() => {
      });
    },
    getAllUserData(api_token){
      this.loading = true
        this.$axios.post(`getAllUserData`,{},
        {
          headers: {
            'api_token':api_token
          }
        })
        .then(res => {
          const data = res.data.data;
          this.authUser(data)

          const aq = data.user.user_detail.all_question;
          if(!aq){
            this.modal_question = true;
          }

          this.loading = false
          
        })
        .catch(err => {
          this.UserLogout();

          this.$cookies.remove('api_token')

          this.loading = false
          this.$router.replace({name:'Home'})
        });
    }
  },
  created() {
    this.checkAlert()
    this.socket = io(this.socketUrl);

    const api_token = this.getToken();
    if(api_token){
      this.getAllUserData(api_token)
    }

    this.socket.on('user_data', (data) => {
      if(data == api_token)
      {
        this.getAllUserData(api_token);
      }
    });

    this.socket.on('convertor_status', () => {
      this.getSetting();
    });

  },
  mounted(){
    this.getSetting()

    // const token = this.getToken();

    // this.ws = new WebSocket(this.webSocketUrl);
    // this.ws.addEventListener("open", () =>{
      
    //   console.log('Connected to ws server successfully');
    //   // const data = {
    //   //   event:'test',
    //   //   data:{},
    //   //   token:token
    //   // }
    //   // this.ws.send(JSON.stringify(data));
      
    // });
    
    // this.ws.addEventListener('message', function (event) {
      
    //   console.log(event);
    //   let socket_data;
    //   if (event.data instanceof Blob) {
    //     const reader = new FileReader();
    //     reader.onload = () => {
    //       const res = reader.result;
    //       socket_data = JSON.parse(res);
    //     };
    //     reader.readAsText(event.data);
    //   } else {
    //     socket_data = JSON.parse(event.data);
    //   }

    //   if(socket_data.event == 'user_data' && socket_data.token == token)
    //   {
    //     console.log('getting again');
    //     this.getAllUserData(token)
    //   }
      
    // });

  }
};
</script>
<style>
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
  
</style>